import React, { useEffect, useState, useCallback } from "react";
import { Box, Button, TextField, Typography } from "@mui/material";
import axiosInstance from "../../utils/axiosInstance";

const AirbnbUnits = ({ airbnbId }) => {
  const [units, setUnits] = useState([]);
  const [unitForm, setUnitForm] = useState({ unit_name: "", price: "", description: "" });

  const fetchUnits = useCallback(async () => {
    const res = await axiosInstance.get(`/airbnbs/${airbnbId}/units`);
    setUnits(res.data);
  }, [airbnbId]);

  useEffect(() => {
    fetchUnits();
  }, [fetchUnits]);

  const handleAddUnit = async () => {
    await axiosInstance.post(`/airbnbs/${airbnbId}/units`, unitForm);
    setUnitForm({ unit_name: "", price: "", description: "" });
    fetchUnits();
  };

  const handleDeleteUnit = async (unitId) => {
    await axiosInstance.delete(`/airbnbs/units/${unitId}`);
    fetchUnits();
  };

  return (
    <Box>
      <Typography variant="h6">Units</Typography>
      <Box display="flex" gap={2} mb={2}>
        <TextField label="Unit Name" value={unitForm.unit_name} onChange={(e) => setUnitForm({ ...unitForm, unit_name: e.target.value })} />
        <TextField label="Price" value={unitForm.price} onChange={(e) => setUnitForm({ ...unitForm, price: e.target.value })} />
        <TextField label="Description" value={unitForm.description} onChange={(e) => setUnitForm({ ...unitForm, description: e.target.value })} />
        <Button variant="contained" onClick={handleAddUnit}>Add Unit</Button>
      </Box>

      {units.map((unit) => (
        <Box key={unit.id} display="flex" justifyContent="space-between" alignItems="center" mb={1}>
          <span>{unit.unit_name} - Ksh {unit.price}</span>
          <Button color="error" onClick={() => handleDeleteUnit(unit.id)}>Delete</Button>
        </Box>
      ))}
    </Box>
  );
};

export default AirbnbUnits;
